/**
 * Determines what payment method icons to show for each country
 */
export const ADYEN_EU_PAYMENT_METHODS_ICONS = 'ADYEN_EU_PAYMENT_METHODS_ICONS';
